"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _ConversationThread = _interopRequireDefault(require("./ConversationThread"));

var _ChatComposer = _interopRequireDefault(require("./ChatComposer"));

var _ReasoningTrace = require("./ReasoningTrace");

var _forethoughtApi = require("./forethoughtApi");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _AIAnswersHeader = _interopRequireDefault(require("../SmartSummary/AIAnswersHeader"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GENERIC_FAILURE_MESSAGE = 'The AI assistant is temporarily unavailable. Please try again.';
/**
 * Picks a user-safe message out of an unknown thrown value. ForethoughtApiError
 * is constructed with a generic, status-aware sentence in `forethoughtApi.ts`.
 * Plain Errors (e.g. network failures from fetch itself) are replaced with a
 * generic message so raw HTML / stack traces never reach the chat.
 */

function userFacingError(err) {
  if (err instanceof _forethoughtApi.ForethoughtApiError) {
    return err.message;
  }

  return GENERIC_FAILURE_MESSAGE;
}

function generateId() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 8));
}

function isEscalation(components) {
  return components.some(function (c) {
    return c.type === 'zendesk_handoff' || c.type === 'salesforce_handoff' || c.type === 'zendesk_ticket_creation';
  });
}

var ForethoughtAgentCard = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ForethoughtAgentCard, _PureComponent);

  var _super = _createSuper(ForethoughtAgentCard);

  function ForethoughtAgentCard() {
    var _this;

    (0, _classCallCheck2.default)(this, ForethoughtAgentCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      conversationId: null,
      turns: [],
      isLoading: false,
      isEscalated: false,
      error: null,
      impressionTracked: false,
      contentVisibleAt: null,
      readTimeTimerId: null,
      resultsVisible: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isMountedFlag", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "readTimeInitiated", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "readTimeObserver", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resultsObserver", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "bodyRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastInitiatedQuery", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inFlight", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "abortController", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchSubmit", function (e) {
      if (e.key !== 'Enter') return;
      var target = e.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'search') return;
      if (!target.closest('.instant-search-wrapper')) return;
      var query = target.value.trim();
      if (!query) return;
      if (query === _this.lastInitiatedQuery) return;
      _this.lastInitiatedQuery = query;
      void _this.startNewConversation(query);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchClear", function (e) {
      var target = e.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'search') return;
      if (!target.closest('.search-box-wrapper')) return;
      if (target.value.trim() !== '') return;

      _this.resetConversation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchClearClick", function (e) {
      if (!(e.target instanceof Element)) return;
      var icon = e.target.closest('.post-icon-wrapper');
      if (!icon) return;
      if (!icon.closest('.search-box-wrapper')) return;

      _this.resetConversation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackForethoughtEvent", function (eventType, elementName) {
      var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Swallow errors here so click handlers that call this (e.g.
      // `handleFollowUpPill`, `handleShowAllResultsClick`) never crash the UI
      // if the underlying tracker fails. Logged for debugging, never surfaced.
      try {
        var _ref, _ForethoughtAgentCard;

        var searchQuery = (_ref = (_ForethoughtAgentCard = ForethoughtAgentCard.readUrlQuery()) !== null && _ForethoughtAgentCard !== void 0 ? _ForethoughtAgentCard : _this.lastInitiatedQuery) !== null && _ref !== void 0 ? _ref : '';

        _publish.default.trackEvent('userevent', _objectSpread({
          type: eventType,
          boundedContext: 'Search',
          entity: 'forethought-ai-answers',
          elementName: elementName,
          eventDetail: "search.forethought-ai-answers.".concat(elementName),
          trackType: 'click',
          searchQuery: searchQuery
        }, extraProps));
      } catch (err) {
        console.warn('[Forethought] trackEvent failed:', err);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackImpression", function (reason) {
      if (_this.state.impressionTracked) return;
      var extraProps = {
        trackType: 'impression',
        impressionReason: reason
      };

      if (reason === 'read_time' && _this.state.contentVisibleAt !== null) {
        extraProps.readTimeSeconds = Math.round((Date.now() - _this.state.contentVisibleAt) / 1000).toString();
      }

      _this.trackForethoughtEvent('Forethought Impression', 'forethoughtImpression', extraProps);

      _this.setState({
        impressionTracked: true
      }); // Interaction-driven impressions short-circuit the read-time timer — no
      // point running it once we already counted the impression.


      if (reason !== 'read_time') {
        _this.clearReadTimeTimer();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleComposerSend", function (query) {
      _this.trackForethoughtEvent('Forethought Follow Up Clicked', 'forethoughtFollowUpClicked', {
        followUpQuery: query
      });

      _this.trackImpression('composer_submit');

      void _this.sendFollowUp(query);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFollowUpPill", function (suggestion) {
      _this.trackForethoughtEvent('Forethought Follow Up Clicked', 'forethoughtFollowUpClicked', {
        followUpQuery: suggestion
      });

      _this.trackImpression('follow_up_click');

      void _this.sendFollowUp(suggestion);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShowAllResultsClick", function () {
      _this.trackForethoughtEvent('Forethought Show All Results Clicked', 'forethoughtShowAllResultsClicked');

      _this.trackImpression('show_all_results_click');

      var target = document.querySelector('.search-query-info');

      if (target instanceof HTMLElement) {
        target.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSourceArticleClick", function (article) {
      var _article$title, _article$link, _article$source_type;

      _this.trackForethoughtEvent('Forethought Related Article Clicked', 'forethoughtRelatedArticleClicked', {
        articleTitle: (_article$title = article.title) !== null && _article$title !== void 0 ? _article$title : '',
        articleUrl: (_article$link = article.link) !== null && _article$link !== void 0 ? _article$link : '',
        articleSourceType: (_article$source_type = article.source_type) !== null && _article$source_type !== void 0 ? _article$source_type : ''
      });

      _this.trackImpression('related_article_click');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleContentArticleClick", function (e) {
      var _anchor$textContent, _anchor$href;

      var target = e.target;
      if (!(target instanceof Element)) return;
      var anchor = target.closest('.forethought-agent__related-articles a');
      if (!anchor) return;

      _this.trackForethoughtEvent('Forethought Content Article Clicked', 'forethoughtContentArticleClicked', {
        articleTitle: ((_anchor$textContent = anchor.textContent) !== null && _anchor$textContent !== void 0 ? _anchor$textContent : '').trim(),
        articleUrl: (_anchor$href = anchor.href) !== null && _anchor$href !== void 0 ? _anchor$href : ''
      });

      _this.trackImpression('content_article_click');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleButtonSelect", function (outputVariable, value, displayName) {
      _this.appendTurn({
        id: generateId(),
        role: 'user',
        content: displayName,
        components: [],
        timestamp: Date.now()
      });

      void _this.sendFollowUp('', (0, _defineProperty2.default)({}, outputVariable, value));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFormSubmit", function (values) {
      var labels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var summary = Object.entries(values).filter(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            v = _ref3[1];

        return v;
      }).map(function (_ref4) {
        var _labels$k;

        var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
            k = _ref5[0],
            v = _ref5[1];

        return "".concat((_labels$k = labels[k]) !== null && _labels$k !== void 0 ? _labels$k : k, ": ").concat(v);
      }).join(', ');

      if (summary) {
        _this.appendTurn({
          id: generateId(),
          role: 'user',
          content: summary,
          components: [],
          timestamp: Date.now()
        });
      }

      void _this.sendFollowUp('', values);
    });
    return _this;
  }

  (0, _createClass2.default)(ForethoughtAgentCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$bodyRef$current;

      this.isMountedFlag = true; // Initial load: if the URL already has ?q=..., kick off a conversation once.
      // We read the URL directly (not searchState.query) because searchState.query updates
      // on every keystroke via the debounced SearchBox, which would cause a new conversation
      // per character typed.

      var urlQuery = ForethoughtAgentCard.readUrlQuery();

      if (urlQuery) {
        this.lastInitiatedQuery = urlQuery;
        void this.startNewConversation(urlQuery);
      } // Subsequent submits: fire when the user presses Enter inside the search input.


      document.addEventListener('keydown', this.handleSearchSubmit, true); // Reset the agent state whenever the user clears the search box.
      // - `input` catches keyboard-driven clearing (backspace, select+delete, etc.)
      //   because those fire native input events.
      // - `click` catches the X icon in `SearchInputWithIcons`, which clears the
      //   value by writing `input.current.value = ''` directly. Programmatic
      //   value writes don't fire input events, so we have to watch the icon
      //   click separately.

      document.addEventListener('input', this.handleSearchClear, true);
      document.addEventListener('click', this.handleSearchClearClick, true); // Delegated click listener for inline article-link lists. Attached to the
      // scrollable body (rather than the document) so it auto-cleans with the
      // ref and so we don't intercept clicks elsewhere on the page.

      (_this$bodyRef$current = this.bodyRef.current) === null || _this$bodyRef$current === void 0 ? void 0 : _this$bodyRef$current.addEventListener('click', this.handleContentArticleClick);
      this.setupResultsVisibilityObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$bodyRef$current2, _this$abortController;

      this.isMountedFlag = false;
      document.removeEventListener('keydown', this.handleSearchSubmit, true);
      document.removeEventListener('input', this.handleSearchClear, true);
      document.removeEventListener('click', this.handleSearchClearClick, true);
      (_this$bodyRef$current2 = this.bodyRef.current) === null || _this$bodyRef$current2 === void 0 ? void 0 : _this$bodyRef$current2.removeEventListener('click', this.handleContentArticleClick);
      this.cleanupReadTimeTracking();

      if (this.resultsObserver) {
        this.resultsObserver.disconnect();
        this.resultsObserver = null;
      }

      (_this$abortController = this.abortController) === null || _this$abortController === void 0 ? void 0 : _this$abortController.abort();
      this.abortController = null;
    } // No `componentDidUpdate` scroll choreography. The component intentionally
    // never moves the page on its own — agent replies, new user turns, and
    // typing-indicator transitions all render in place and the user stays in
    // control of their viewport. The "Show all results" pill provides the one
    // explicit scroll affordance for users who want to jump past the agent.

  }, {
    key: "cancelInFlight",
    value: function cancelInFlight() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    }
  }, {
    key: "resetConversation",
    value:
    /**
     * Wipes the conversation and any in-flight request. No-op when there's
     * nothing to reset, so this can be called from broad event handlers without
     * burning a needless render on every keystroke.
     */
    function resetConversation() {
      var _this$state = this.state,
          turns = _this$state.turns,
          conversationId = _this$state.conversationId,
          isLoading = _this$state.isLoading,
          error = _this$state.error;

      if (turns.length === 0 && conversationId === null && !isLoading && !error) {
        return;
      }

      this.cancelInFlight();
      this.lastInitiatedQuery = null;
      this.cleanupReadTimeTracking();
      this.setState({
        conversationId: null,
        turns: [],
        isLoading: false,
        isEscalated: false,
        error: null,
        impressionTracked: false,
        contentVisibleAt: null,
        readTimeTimerId: null
      });
    }
    /**
     * Keyboard-driven clearing (backspace, select+delete) — the native `input`
     * event fires on the search input, and we reset once the value is empty.
     */

  }, {
    key: "appendTurn",
    value: function appendTurn(turn) {
      this.setState(function (prev) {
        return {
          turns: [].concat((0, _toConsumableArray2.default)(prev.turns), [turn])
        };
      });
    }
    /**
     * @param kind 'answer' = response to the initial query (POST /conversation).
     *             'reply'  = response to a follow-up (PUT /conversation/{id}).
     *             Drives whether we emit `forethoughtAnswerGeneration` (one per
     *             conversation, signals "AI replaced a search result") or
     *             `forethoughtReplyGeneration` (per follow-up turn, signals
     *             "user kept chatting"). Separating the two lets analytics
     *             distinguish first-touch usage from ongoing engagement.
     */

  }, {
    key: "appendAgentResponse",
    value: function appendAgentResponse(response, responseTimeMs, kind) {
      var _response$widget_comp, _response$widget_comp2;

      var turn = {
        id: generateId(),
        role: 'agent',
        content: '',
        components: (_response$widget_comp = response.widget_components) !== null && _response$widget_comp !== void 0 ? _response$widget_comp : [],
        timestamp: Date.now(),
        responseTimeMs: responseTimeMs,
        articles: (0, _ReasoningTrace.extractArticlesFromComponents)((_response$widget_comp2 = response.widget_components) !== null && _response$widget_comp2 !== void 0 ? _response$widget_comp2 : []),
        reasoning: response.reasoning
      };
      this.setState(function (prev) {
        return {
          turns: [].concat((0, _toConsumableArray2.default)(prev.turns), [turn]),
          conversationId: response.conversation_id || prev.conversationId,
          isEscalated: prev.isEscalated || isEscalation(turn.components)
        };
      }); // Telemetry is wrapped so a tracker failure (e.g. consent gating, network
      // hiccup, IntersectionObserver unavailable) never propagates to the
      // outer API try/catch — that catch is for actual conversation failures.
      // Without this guard a thrown tracker call would set `state.error` to the
      // generic "temporarily unavailable" message even though the agent
      // response had already rendered successfully.

      try {
        if (kind === 'answer') {
          this.trackForethoughtEvent('Forethought Answer Generation', 'forethoughtAnswerGeneration', {
            trackType: 'generation',
            responseTimeMs: String(responseTimeMs)
          }); // The first agent response has now rendered — start the 10s read-time
          // observer so the impression fires from passive viewing if the user
          // doesn't click anything. Interaction-triggered impressions short-circuit
          // the timer (see `trackImpression`).

          this.setupReadTimeTracking();
        } else {
          this.trackForethoughtEvent('Forethought Reply Generation', 'forethoughtReplyGeneration', {
            trackType: 'generation',
            responseTimeMs: String(responseTimeMs)
          });
        }
      } catch (telemetryErr) {
        console.warn('[Forethought] telemetry failed:', telemetryErr);
      }
    }
    /**
     * Mirrors `SmartSummary#trackAIAnswersEvent`. Centralized so every event
     * we emit from the agent (generations, clicks, follow-ups, impressions)
     * shares the same shape and the same `boundedContext` / `entity` pair.
     * Analytics dashboards then partition Forethought-vs-AI-Answers via the
     * `entity` field alone.
     */

  }, {
    key: "setupReadTimeTracking",
    value:
    /**
     * Sets up the 10s-visible IntersectionObserver. Called after the first agent
     * response renders (so the observer has real content to watch). Mirrors the
     * SmartSummary pattern: threshold 0.5, fires once, then disconnects.
     */
    function setupReadTimeTracking() {
      var _this2 = this;

      if (this.readTimeInitiated) return;
      var target = this.bodyRef.current;
      if (!target || typeof IntersectionObserver === 'undefined') return;

      try {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (_this2.readTimeInitiated) return;
            _this2.readTimeInitiated = true;
            var visibleAt = Date.now();
            var timerId = window.setTimeout(function () {
              if (!_this2.isMountedFlag) return;

              _this2.trackImpression('read_time');
            }, 10000);

            _this2.setState({
              contentVisibleAt: visibleAt,
              readTimeTimerId: timerId
            });

            observer.disconnect();
          });
        }, {
          threshold: 0.5
        });
        observer.observe(target);
        this.readTimeObserver = observer;
      } catch (err) {
        console.warn('[Forethought] read-time observer setup failed:', err);
      }
    }
    /**
     * Observes `.instant-search__results-wrapper` (rendered by `InstantSearch`
     * below the agent) and flips `state.resultsVisible` whenever it crosses the
     * viewport boundary. The "Show all results" button uses this flag to hide
     * itself once the user has reached the results — leaving it on-screen at
     * that point is redundant noise.
     *
     * The results wrapper is rendered by a sibling component, so we
     * `querySelector` for it from the document instead of holding a ref. Safe
     * because the selector is stable (it's the established class name used by
     * the "Show all results" click handler as well).
     *
     * Retries with `requestAnimationFrame` once if the element isn't in the DOM
     * yet at mount time — InstantSearch streams its layout in around the same
     * tick the agent mounts, and on slow renders the element can be a frame
     * behind us.
     */

  }, {
    key: "setupResultsVisibilityObserver",
    value: function setupResultsVisibilityObserver() {
      var _this3 = this;

      var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (typeof IntersectionObserver === 'undefined') return;
      var target = document.querySelector('.instant-search__results-wrapper');

      if (!target) {
        if (retry) {
          requestAnimationFrame(function () {
            return _this3.setupResultsVisibilityObserver(false);
          });
        }

        return;
      }

      try {
        this.resultsObserver = new IntersectionObserver(function (entries) {
          var visible = entries.some(function (e) {
            return e.isIntersecting;
          });
          if (!_this3.isMountedFlag) return;
          if (_this3.state.resultsVisible === visible) return;

          _this3.setState({
            resultsVisible: visible
          });
        }, // Any sliver of the wrapper showing counts as "visible" — the goal is
        // to hide the button the moment the user has reached the section, not
        // to wait until half of it is on-screen.
        {
          threshold: 0
        });
        this.resultsObserver.observe(target);
      } catch (err) {
        console.warn('[Forethought] results visibility observer setup failed:', err);
      }
    }
  }, {
    key: "clearReadTimeTimer",
    value: function clearReadTimeTimer() {
      if (this.state.readTimeTimerId !== null) {
        window.clearTimeout(this.state.readTimeTimerId);

        if (this.isMountedFlag) {
          this.setState({
            readTimeTimerId: null
          });
        }
      }
    }
  }, {
    key: "cleanupReadTimeTracking",
    value: function cleanupReadTimeTracking() {
      this.readTimeInitiated = false;
      this.clearReadTimeTimer();

      if (this.readTimeObserver) {
        this.readTimeObserver.disconnect();
        this.readTimeObserver = null;
      }

      if (this.isMountedFlag) {
        this.setState({
          contentVisibleAt: null
        });
      }
    }
  }, {
    key: "startNewConversation",
    value: function () {
      var _startNewConversation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(query) {
        var signal, _yield$startConversat, data, responseTimeMs;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // A new query supersedes any pending request — cancel it so its eventual response
                // doesn't get appended after we've already moved on.
                this.cancelInFlight();
                this.abortController = new AbortController();
                signal = this.abortController.signal; // New conversation = new impression window. Tear down any active observer
                // / pending read-time timer from the prior conversation so the next first
                // response can re-arm them cleanly.

                this.cleanupReadTimeTracking();
                this.setState({
                  conversationId: null,
                  turns: [],
                  isLoading: true,
                  isEscalated: false,
                  error: null,
                  impressionTracked: false,
                  contentVisibleAt: null,
                  readTimeTimerId: null
                });
                this.inFlight = true;
                _context.prev = 6;
                _context.next = 9;
                return (0, _forethoughtApi.startConversation)(query, signal);

              case 9:
                _yield$startConversat = _context.sent;
                data = _yield$startConversat.data;
                responseTimeMs = _yield$startConversat.responseTimeMs;
                this.appendAgentResponse(data, responseTimeMs, 'answer');
                this.setState({
                  isLoading: false
                });
                _context.next = 23;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](6);

                if (!signal.aborted) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("return");

              case 20:
                console.error('[Forethought] startConversation failed:', _context.t0); // Allow retrying the same query after an error.

                this.lastInitiatedQuery = null;
                this.setState({
                  isLoading: false,
                  error: userFacingError(_context.t0)
                });

              case 23:
                _context.prev = 23;
                this.inFlight = false;
                return _context.finish(23);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 16, 23, 26]]);
      }));

      function startNewConversation(_x) {
        return _startNewConversation.apply(this, arguments);
      }

      return startNewConversation;
    }()
  }, {
    key: "sendFollowUp",
    value: function () {
      var _sendFollowUp = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(query) {
        var contextVariables,
            conversationId,
            signal,
            _yield$continueConver,
            data,
            responseTimeMs,
            status,
            isConversationGone,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                contextVariables = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                if (!this.inFlight) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                conversationId = this.state.conversationId;

                if (conversationId) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return this.startNewConversation(query);

              case 7:
                return _context2.abrupt("return");

              case 8:
                // Follow-ups also get an abort handle so unmount mid-flight doesn't strand the request.
                this.cancelInFlight();
                this.abortController = new AbortController();
                signal = this.abortController.signal;

                if (query) {
                  this.appendTurn({
                    id: generateId(),
                    role: 'user',
                    content: query,
                    components: [],
                    timestamp: Date.now()
                  });
                }

                this.setState({
                  isLoading: true,
                  error: null
                });
                this.inFlight = true;
                _context2.prev = 14;
                _context2.next = 17;
                return (0, _forethoughtApi.continueConversation)(conversationId, query || null, contextVariables, signal);

              case 17:
                _yield$continueConver = _context2.sent;
                data = _yield$continueConver.data;
                responseTimeMs = _yield$continueConver.responseTimeMs;
                this.appendAgentResponse(data, responseTimeMs, 'reply');
                this.setState({
                  isLoading: false
                });
                _context2.next = 38;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](14);

                if (!signal.aborted) {
                  _context2.next = 28;
                  break;
                }

                return _context2.abrupt("return");

              case 28:
                console.error('[Forethought] continueConversation failed:', _context2.t0); // 400/404 on continue means the upstream conversation has expired or no longer
                // exists (Solve drops sessions after ~1h of inactivity). When we still have the
                // user's query, transparently retry it as a fresh conversation so the user
                // doesn't need to resubmit. For empty-query continue calls (button clicks /
                // form submits with no free-text input) we can't synthesize a new POST start,
                // so surface a clear "send again" prompt instead.

                status = _context2.t0 instanceof _forethoughtApi.ForethoughtApiError ? _context2.t0.status : undefined;
                isConversationGone = status === 400 || status === 404;

                if (!(isConversationGone && query)) {
                  _context2.next = 37;
                  break;
                }

                // Reset state so startNewConversation builds a clean thread. We drop the
                // stale user turn we appended above because startNewConversation will
                // append its own.
                this.inFlight = false;
                this.setState({
                  conversationId: null,
                  turns: [],
                  error: null
                });
                _context2.next = 36;
                return this.startNewConversation(query);

              case 36:
                return _context2.abrupt("return");

              case 37:
                this.setState(function (prevState) {
                  return {
                    conversationId: isConversationGone ? null : prevState.conversationId,
                    isLoading: false,
                    error: isConversationGone ? 'That conversation expired. Send your message again to continue.' : userFacingError(_context2.t0)
                  };
                });

              case 38:
                _context2.prev = 38;
                this.inFlight = false;
                return _context2.finish(38);

              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[14, 24, 38, 41]]);
      }));

      function sendFollowUp(_x2) {
        return _sendFollowUp.apply(this, arguments);
      }

      return sendFollowUp;
    }() // Enter-driven submit from the in-conversation `ChatComposer`. Counted as a
    // follow-up the same way an explicit pill tap is — same event type, same
    // shape — so analytics doesn't have to special-case keyboard vs. mouse.

  }, {
    key: "render",
    value: function render() {
      var hidden = this.props.hidden;
      var _this$state2 = this.state,
          turns = _this$state2.turns,
          isLoading = _this$state2.isLoading,
          error = _this$state2.error,
          isEscalated = _this$state2.isEscalated,
          resultsVisible = _this$state2.resultsVisible; // `--active` enables the fixed-height + scrollable-body layout. Gated on
      // the presence of at least one turn (i.e. the first real response has
      // arrived) — during the initial loading state we want the panel to stay
      // compact around the typing indicator instead of jumping to a 700px box
      // before there's any content to put in it. After the first reply lands,
      // follow-ups keep `--active` on because the turn list isn't empty.

      var isActive = turns.length > 0;
      var wrapperClass = "forethought-agent".concat(isActive ? ' forethought-agent--active' : '');
      return (0, _preact.h)("div", {
        className: wrapperClass,
        hidden: hidden
      }, (0, _preact.h)("div", {
        className: "forethought-agent__body",
        ref: this.bodyRef
      }, (0, _preact.h)("div", {
        className: "forethought-agent__header"
      }, (0, _preact.h)(_AIAnswersHeader.default, {
        title: "AI Community Agent"
      })), (0, _preact.h)("hr", {
        className: "forethought-agent__divider",
        "aria-hidden": "true"
      }), !turns.length && !isLoading && (0, _preact.h)("div", {
        className: "forethought-agent__empty"
      }, "Type your question above and press Enter \u2014 the AI agent will respond here."), (turns.length > 0 || isLoading) && (0, _preact.h)(_ConversationThread.default, {
        turns: turns,
        isLoading: isLoading,
        disabled: isLoading || isEscalated,
        onButtonSelect: this.handleButtonSelect,
        onFormSubmit: this.handleFormSubmit,
        onFollowUpSelect: this.handleFollowUpPill,
        onSourceClick: this.handleSourceArticleClick
      }), error && (0, _preact.h)("div", {
        className: "forethought-agent__error"
      }, error)), turns.length > 0 && !isEscalated && (0, _preact.h)("hr", {
        className: "forethought-agent__divider",
        "aria-hidden": "true"
      }), turns.length > 0 && !isEscalated && (0, _preact.h)(_ChatComposer.default, {
        disabled: isLoading,
        onSend: this.handleComposerSend,
        placeholder: "Ask a follow-up\u2026"
      }), turns.length > 0 && !isEscalated && !resultsVisible && (0, _preact.h)("button", {
        type: "button",
        className: "forethought-agent__show-results",
        onClick: this.handleShowAllResultsClick,
        "aria-label": "Show all search results"
      }, (0, _preact.h)("span", {
        className: "forethought-agent__show-results-label"
      }, "Show all results"), (0, _preact.h)("svg", {
        className: "forethought-agent__show-results-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true"
      }, (0, _preact.h)("path", {
        d: "M5 8l5 5 5-5",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }))));
    }
  }], [{
    key: "readUrlQuery",
    value: function readUrlQuery() {
      if (typeof window === 'undefined') return null;

      try {
        var _URLSearchParams$get;

        var raw = (_URLSearchParams$get = new URLSearchParams(window.location.search).get('q')) === null || _URLSearchParams$get === void 0 ? void 0 : _URLSearchParams$get.trim();
        return raw !== null && raw !== void 0 ? raw : null;
      } catch (_unused) {
        return null;
      }
    }
  }]);
  return ForethoughtAgentCard;
}(_preactCompat.PureComponent);

var _default = ForethoughtAgentCard;
exports.default = _default;